import client from "../client";
import { ContractorInterface } from "../../models/TicketModule/Contractor";

class ContractorService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/contractors`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<ContractorInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async GetById(id: string) {
    try {
      let url = `/api/contractors/getbyid/${id}`;

      const { data } = await client.get<ContractorInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async Save(contractor: ContractorInterface) {
    try {
      let url = `/api/contractors`;

      const { data } = await client.post<ContractorInterface>(url, contractor);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Update(id: string, contractor: ContractorInterface) {
    try {
      let url = `/api/contractors/update/${id}`;

      const { data } = await client.post<ContractorInterface>(url, contractor);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/contractors/remove/${id}`;
      await client.post<ContractorInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new ContractorService();
